import React from 'react';
import { Outlet } from 'react-router-dom';
import { Layout, ConfigProvider } from 'antd';
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import SideBar from './components/layout/SideBar';
import Content from './components/layout/Content';
import { DashboardOutlined, ApartmentOutlined, UserOutlined, FileTextOutlined, NotificationOutlined, HomeOutlined } from '@ant-design/icons';
import thTH from 'antd/lib/locale/th_TH';
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import "./App.css";


const items = [{
  name: 'Dashboard',
  path: '/dashboard',
  icon: React.createElement(DashboardOutlined),
},
{
  name: 'Members',
  path: '/customer_level',
  icon: React.createElement(UserOutlined),
  children: [
    {
      name: 'Member',
      path: '/member',
      icon: React.createElement(UserOutlined),
    }, {
      name: 'Customer Level',
      path: '/member/config',
    },]
},
{
  name: 'Affiliate',
  path: '/affiliate',
  icon: React.createElement(ApartmentOutlined),
  children: [{
    name: 'Register',
    path: '/affiliate',
  }, {
    name: 'Config',
    path: '/affiliate/config',
  }, {
    name: 'Payment',
    path: '/affiliate/payment',
  }]
},
{
  name: 'Reward',
  path: '/reward',
  icon: React.createElement(UserOutlined),
  children: [
    {
      name: 'Categories',
      path: '/reward/categories'
    }, {
      name: 'Coupon',
      path: '/coupon',
    }, {
      name: 'User Coupon',
      path: '/user_coupon',
    }, {
      name: 'Topup',
      path: '/topup',
    }]
},
{
  name: 'Report',
  icon: React.createElement(FileTextOutlined),
  children: [{
    name: 'Transaction',
    path: '/payment/transaction',
  },{
    name: 'Transaction 2',
    path: '/payment/transaction2',
  }]
},
{
  name: 'Banner',
  path: '/banner',
  icon: React.createElement(HomeOutlined),
},
{
  name: 'Notification',
  path: '/notification',
  icon: React.createElement(NotificationOutlined),
},
{
  name: 'Admin',
  icon: React.createElement(UserOutlined),
  children: [{
    name: 'Admin',
    path: '/admin',
  }, {
    name: 'Activity Logs',
    path: '/logs/activity',
  }]
},

];



const App: React.FC = () => {

  return (
    <ConfigProvider
      locale={thTH}
      theme={{
        token: {
          fontFamily: "Sriracha"
        }
      }}
    >
      <Layout style={{ minHeight: '100vh' }}>
        <Header />
        <Layout>

          <SideBar
            items={items}
          />

          <Content>
            <Outlet></Outlet>
          </Content>

        </Layout>
        <Footer />
      </Layout>
    </ConfigProvider>
  );
};

export default App;